import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryUserTreeList } from '@/api/api';
import SelectAssetModal from "../../../assets/SelectAssetModal";
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'JobOrderModal',
  mixins: [ModalFormMixin],
  components: {
    SelectAssetModal: SelectAssetModal,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '派工单表单',
      siteName: '',
      tableName: 'om_job_order',

      /* 星级评价开始*/
      starNum: 5,
      starDesc: ['非常差', '差', '一般', '良好', '优秀'],

      /* 星级评价结束*/
      form_fields: ['siteId', 'originId', 'originKey', 'tenantId', 'userId', 'category', 'jobLevel', 'assetId', 'errorCode', 'remark', 'title', 'solution', 'status', 'starNum', 'comment'],
      form_fields_time: ['startTime', 'endTime', 'completionTime'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择处理人员!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择任务类型'
          }]
        },
        jobLevel: {
          rules: [{
            required: true,
            message: '请选择任务级别'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        },
        originKey: {
          rules: [{
            required: true,
            message: '请选择故障来源!'
          }]
        }
      },
      url: {
        add: '/om/job/order'
      },
      userTree: [],
      //人员信息
      selectedAsset: [],
      assetIds: []
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadTreeList();
      this.selectedAsset = [];
      this.assetIds = [];
      this.disableSubmit = this.showCheck ? true : this.disableSubmit;

      if (this.model.id || this.addJob) {
        this.assetIds = this.model.assetId ? this.model.assetId : null;
        this.model.productName = this.model.productName ? this.model.productName : null;
        this.selectedAsset.push(this.model.productName);
        this.siteName = this.model.siteName;
      } else {
        this.model.startTime = new Date().toLocaleDateString();
      }

      if (this.model.id && !this.model.completionTime && this.model.status == 2) {
        this.model.completionTime = new Date().toLocaleDateString();
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
        that.$refs.iwupload.loadUploadFiles();
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    selectAssets: function selectAssets() {
      this.$refs.AssetListModal.siteId = this.currentSiteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(this.selectedAsset, this.assetIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedAsset = [];
      this.assetIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedAsset.push(productList[i].productName);
        this.assetIds = productList[i].id;
      }
    },
    handleOk: function handleOk(s) {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.starNum = that.starNum; //时间格式化

          formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD') : null;
          formData.startTime = formData.startTime ? formData.startTime.format('YYYY-MM-DD') : null;
          formData.completionTime = formData.completionTime ? moment(formData.completionTime).format('YYYY-MM-DD') : null;
          formData.assetId = that.assetIds && (that.assetIds == [] || that.assetIds.length == 0) ? '' : that.assetIds;
          formData.siteId = formData.siteId ? formData.siteId : _this2.currentSiteId;
          formData.changeStatus = !formData.status ? 1 : s == 2 ? 2 : s == 3 ? 3 : s == 1 ? formData.status : 1;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};